import PropTypes from 'prop-types';
import cx from 'classnames';

import { resolveScopedStyles } from 'core/utils/styled-jsx';

import SmartImage from 'core/components/SmartImage';
import Progressbar from 'core/components/GameCompare/Progressbar';
import ImageAmp from 'core/components/SmartImage/Amp';

import { PAIR_COMPARE } from '../constants';

import styles from './index.styl';

const maxPercentFirstImage = 60;
const maxPercentSecondImage = 65;


// Стили вынесены в style jsx для amp страниц
function Lightning(props, { amp }) {
  const {
    pair,
    widget,
    progressType,
    progressInside,
    height,
    progress,
    imageMaxWidth,
    borderRadius,
    lightningColor,
  } = props;

  if (pair?.length < 2 && !widget) return null;

  let firstCouple = pair;

  if (widget) {
    const {
      variants,
      left_winner: leftWinner,
      right_winner: rightWinner,
    } = widget?.attributes || {};

    firstCouple = widget.type ===  PAIR_COMPARE ? [leftWinner, rightWinner] : variants?.slice(0, 2);
  }

  const scoped = resolveScopedStyles(
    <scope>
      <style jsx>{`
        .${styles.img_0}
          background-color ${lightningColor}
      `}</style>
    </scope>
  );

  const maxWidthFirstImage = (imageMaxWidth * maxPercentFirstImage) / 100;
  const maxWidthSecondImage = (imageMaxWidth * maxPercentSecondImage) / 100;

  return (
    <div className={cx('images', amp && '_amp')}>
      <style jsx>{`
        .images
          border-radius ${borderRadius}
          max-width ${imageMaxWidth}px
          display flex
          flex 1 1 auto
          position relative
          overflow hidden

        .progress
          position absolute
          top 50%
          right 0
          transform translateY(-50%)
          z-index 1
          ._amp &
            margin-right -28px

        .wrapper
          position relative
          width 100%
        
        :global(amp-img)
          height 100%
      `}</style>
      {firstCouple.map((couple, i) => {
        const {
          image: {
            attributes: {
              versions: {
                original: originalCover,
                thumbnail: previewCover,
              },
            },
          },
        } = couple.attributes || couple;

        return (
          <div
            key={couple.id}
            className={amp ? 'wrapper' : styles[`wrapper_${i}`]}
          >
            {amp ? (
              <ImageAmp
                src={originalCover}
                aspectRatio={1.5}
              />
            ) : (
              <SmartImage
                src={originalCover}
                previewSrc={previewCover}
                maxWidth={i === 0 ? maxWidthFirstImage : maxWidthSecondImage}
                height={height}
                className={scoped.wrapClassNames(styles[`img_${i}`])}
                smart
              />
            )}
            {!i && (
              <div className='progress'>
                <Progressbar
                  type={progressType}
                  progressInside={progressInside}
                  {...progress && { progress }}
                />
              </div>
            )}
          </div>
        );
      })}
      <scoped.styles />
    </div>
  );
}

Lightning.contextTypes = {
  amp: PropTypes.bool,
};

Lightning.propTypes = {
  pair: PropTypes.array,
  widget: PropTypes.object,
  progressType: PropTypes.number,
  height: PropTypes.number,
  progress: PropTypes.number,
  progressInside: PropTypes.bool,
  imageMaxWidth: PropTypes.number,
  borderRadius: PropTypes.string,
  lightningColor: PropTypes.string,
};

export default Lightning;
